// https://github.com/elwayman02/ember-scroll-modifiers/blob/v4.1.0/addon/modifiers/scroll-into-view.js
import { modifier } from 'ember-modifier';

interface ScrollIntoViewSignature {
  Args: {
    Named: {
      options?: Record<string, unknown>;
      shouldScroll?: boolean;
    };
    Positional: [];
  };
  Element: Element;
}

/**
 * @deprecated
 */
export default modifier<ScrollIntoViewSignature>(
  function scrollIntoView(element, _positional, named) {
    const { options, shouldScroll } = named;
    let hasBeenRemoved: boolean = false;

    const shouldScrollPromise = Promise.resolve(shouldScroll);

    void shouldScrollPromise.then((shouldScrollValue): void => {
      if (shouldScrollValue && element && !hasBeenRemoved) {
        if (
          options?.['topOffset'] === undefined &&
          options?.['leftOffset'] === undefined
        ) {
          element.scrollIntoView(options);
        } else {
          const behavior = options['behavior'] ?? 'auto';

          const left =
            options['leftOffset'] === undefined
              ? 0
              : element.getBoundingClientRect().left -
                document.body.getBoundingClientRect().left -
                // @ts-expect-error: Incorrect type
                options['leftOffset'];

          const top =
            options['topOffset'] === undefined
              ? 0
              : element.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                // @ts-expect-error: Incorrect type
                options['topOffset'];

          // @ts-expect-error: Incorrect type
          window?.scrollTo({ behavior, left, top });
        }
      }
    });

    return (): void => {
      hasBeenRemoved = true;
    };
  },
);
